var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569",
    transform: "translate(-1810 -108)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    "data-name": "Ellipse 43",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(1810 108)",
    fill: "#191b1f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "dollar-sign",
    "data-name": "$",
    transform: "translate(1822 132)",
    fill: "#00ff5f",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/DollarSign.3528e52bd581ee698b763153db1d6832.svg";
export { ForwardRef as ReactComponent };